import React, { useEffect } from 'react'
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import R1 from "../r1.jpg";

export default function Middlesec() {
  
  var [m_Time, s_time] = useState({ date: "", time: "" });
  var arr_of_buttons = ["btn_1_", "btn_2_", "btn_3_"];
  var main_falsy;
  var [onscreen, setonscreen] = useState([
    { one_1: false },
    { two_2: true },
    { three_3: true },
  ]);
  setInterval(() => {
    var date = new Date();
    var d = [date.getDate(), date.getDay(), date.getFullYear()];
    var b = d.join("-");
    var hours;
    if (date.getHours() > 12) {
      hours = date.getHours() - 12;
    } else {
      hours = date.getHours();
    }
    var time = [hours, date.getMinutes(), date.getSeconds()].join(":");
    s_time({
      date: b,
      time: time,
    });
  }, 1000);
  var arr_of_div = ["one_1", "one_2", "one_3"];

  function eventclicker(e) {
    var { id } = e.target;
    // console.log(id.split("_")[2]);
    var movedelement = e.target.parentElement.parentElement.childNodes[0];
    var main_id = id.split("_")[2];
    console.log({ destinations: main_id });
    var falsy = onscreen.filter((e) => {
      // console.log(Object.values(e)[0]);
      if (!Object.values(e)[0]) {
        return e;
      }
    });
    console.log(falsy);
    var parent = Object.keys(falsy[0])[0];
    // console.log(parent);
    var percentage;
    parent = parseInt(parent.split("_")[1]);
    console.log({ current: parent });
    var currentelement = parent;
    // console.log(currentelement);
    if (parseInt(main_id) === 2) {
      console.log("this is run");
      if (currentelement < main_id) {
        percentage = main_id - currentelement;
      } else {
        percentage = main_id - currentelement;
      }
      setonscreen([{ one_1: true }, { two_2: false }, { three_3: true }]);
      console.log(onscreen);
    } else if (parseInt(main_id) === 3) {
      if (currentelement < main_id) {
        percentage = main_id - currentelement;
      } else {
        percentage = main_id - currentelement;
      }
      setonscreen([{ one_1: true }, { two_2: true }, { three_3: false }]);
      console.log(onscreen);
    } else if (parseInt(main_id) === 1) {
      if (currentelement < main_id) {
        percentage = main_id - currentelement;
      } else {
        percentage = main_id - currentelement;
      }
      setonscreen([{ one_1: false }, { two_2: true }, { three_3: true }]);
      console.log(onscreen);
    }
    console.log(falsy);
    main_falsy = Object.keys(falsy[0])[0];
    console.log(main_falsy);
    console.log(percentage);
    console.log(movedelement);
    if (!movedelement.style.marginLeft) {
      movedelement.style.marginLeft = `${-percentage * 100}%`;
    } else {
      console.log(
        parseInt(movedelement.style.marginLeft.split("%")[0]) +
          -percentage * 100
      );
      var value =
        parseInt(movedelement.style.marginLeft.split("%")[0]) +
        -percentage * 100;
      movedelement.style.marginLeft = `${value}%`;
    }
    console.log("----------------------------------");
  }

  return (
    // <div>Middlesec</div>
    <div className="Middlersec">
      <div className="imageSlider">
        {arr_of_div.map((e, i) => {
          return (
            <div id={`${e}`} key={i} className="con_same">
              <div className="cont">
                <h1 id="h_">
                  {" "}
                  Write what ever you Love to : That share your Feelings ..{" "}
                </h1>

                <button id="btns"> Continue Reading </button>
              </div>
              <div className="inner_con">{m_Time.time}</div>
            </div>
          );
        })}
        <div className="slidebuttons">
          {arr_of_buttons.map((e, i) => {
            return (
              <button
                onClick={(e) => {
                  // console.log(onscreen);

                  return eventclicker(e);
                }}
                key={i}
                id={`_${e}`}
                className="btns_1"
              ></button>
            );
          })}
        </div>
      </div>
    </div>
  );
}



